<a
  class="action-button action-button-edit grey-button"
  [ngClass]="{ 'responsive-label': responsiveLabel }" [routerLink]="routerLink" [ngbTooltip]="title"
>
  <my-global-icon iconName="edit" aria-hidden="true"></my-global-icon>

  <span class="button-label" *ngIf="label">{{ label }}</span>
</a>
